/**
 * English calendar text (ADR 0093 §4, §10): the names a month is drawn with
 * and the prompts asked about it. The Spanish and French files have the same
 * shape.
 *
 * Weekdays run Sunday first in every language (ADR 0093 §10), so index 0 is
 * Sunday, the same numbering `Date.getUTCDay` uses.
 */
export const calendarText = {
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    /** The column headings, as a wall calendar prints them. */
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    weekdaysPlural: ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'],
    months: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
    ],
    /** First to fourth, then "last" (ADR 0093 §4: never "fifth"). */
    ordinals: ['first', 'second', 'third', 'fourth'],
    last: 'last',
    title: (month: string, year: number) => `${month} ${year}`,
    /** A date as the prompts and the key write it: "October 14". */
    date: (month: string, day: number) => `${month} ${day}`,
};

export const calendarPrompts = {
    dayOfWeek: (date: string) => `What day of the week is ${date}?`,
    findDate: (ordinal: string, weekday: string) => `What is the date of the ${ordinal} ${weekday}?`,
    howManyWeekday: (weekdays: string, month: string) => `How many ${weekdays} are in ${month}?`,
    howManyDays: (month: string) => `How many days are in ${month}?`,
    /** `count` days, or weeks when `weeks` is set; one day reads "the day after". */
    beforeAfter: (count: number, weeks: boolean, after: boolean, date: string) => {
        const direction = after ? 'after' : 'before';
        if (count === 1 && !weeks) {
            return `What date is the day ${direction} ${date}?`;
        }
        const unit = weeks ? (count === 1 ? 'week' : 'weeks') : 'days';
        return `What date is ${count} ${unit} ${direction} ${date}?`;
    },
};
